import client from './client';
import qs from 'qs';

/**
 * 스크립트 카드 리스트
 */
export const cardList = (params) => client.get(`/api/script/card/list`, params);

/**
 * 스크립트 대시보드 리스트
 */
export const getDashboardList = (params) =>
  client.get(`/api/script/card/dashboard`, params);

/**
 * 스크립트 카드 추가
 */
export const cardAdd = (params) =>
  client.post(`/api/script/card/add`, qs.stringify(params));

/**
 * 스크립트 카드 수정
 */
export const cardModify = (params) =>
  client.post(`/api/script/card/modify`, params);

/**
 * 스크립트 카드 삭제
 */
export const cardDelete = (seq) =>
  client.delete(`/api/script/card/delete`, { data: { seq: seq } });

/**
 * 스크립트 카드 주차별 통계
 */
export const cardWeekList = (params) =>
  client.get(`/api/script/card/statistics`, params);

/**
 * 스크립트 카드 중복 확인
 */
export const cardDuplicate = (params) =>
  client.post(`/api/script/card/duplicate`, params);

/**
 * 스크립트
 */
export const getCardInfo = (params) =>
  client.post(`/api/script/card/trello`, params);

/**
 * 스크립트 요청 리스트
 */
export const getRequestList = () => client.get(`/api/script/card/requestList`);

/**
 * 스크립트
 */
export const cardTransfer = (params) =>
  client.post(`/api/script/card/transfer`, params);

/**
 * 스크립트
 */
export const getRankData = (params) => client.get(`/api/script/rank`, params);

/**
 * 월간통계
 */
export const getMonthCntList = (params) =>
  client.get(`/api/trello/monthCount`, params);

/**
 * 사용자 정보
 */
export const getScriptUserInfo = (params) =>
  client.get(`/api/script/user/list`, params);

/**
 * 사용자 정보 트렐로 ID 수정
 */
export const getScriptUserModify = (params) =>
  client.post(`/api/script/user/modify`, params);

/**
 * 미처리 카드 알림
 */
export const sendScriptNotification = (params) =>
  client.get(`/api/script/unprocessed`, params);
